/* =========================================================
   MADSPEED7 — COMPATIBILITY CHECK — ASK AN EXPERT
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  const openButton = document.querySelector(
    '[data-ms7-ask-expert]'
  );

  const popup = document.getElementById(
    'ms7-compatibility-popup'
  );

  if (!openButton || !popup) return;

  const closeButtons = popup.querySelectorAll(
    '[data-ms7-compatibility-close]'
  );

  const form = popup.querySelector(
    '.ms7-compatibility-form'
  );

  const submitButton = popup.querySelector(
    '.ms7-compatibility-form__submit'
  );

  const whatsappButton = popup.querySelector(
    '[data-ms7-compatibility-whatsapp]'
  );

  /*
   * Form fields.
   */
  const nameInput = document.getElementById(
    'MS7Compatibility-name'
  );

  const emailInput = document.getElementById(
    'MS7Compatibility-email'
  );

  const phoneInput = document.getElementById(
    'MS7Compatibility-phone'
  );

  const bikeInput = document.getElementById(
    'MS7Compatibility-bike'
  );

  const yearInput = document.getElementById(
    'MS7Compatibility-year'
  );

  const messageInput = document.getElementById(
    'MS7Compatibility-message'
  );

  const productUrlInput = document.getElementById(
    'MS7Compatibility-product-url'
  );

  const skuInput = document.getElementById(
    'MS7Compatibility-sku'
  );

  /*
   * Open popup.
   */
  function openPopup() {

  popup.style.display = 'block';

  popup.setAttribute(
    'aria-hidden',
    'false'
  );

  document.body.style.overflow = 'hidden';

  updateProductInformation();

 

}

  /*
   * Close popup.
   */
  function closePopup() {

  popup.style.display = 'none';

  popup.setAttribute(
    'aria-hidden',
    'true'
  );

  document.body.style.overflow = '';

}

  /*
   * Get current product information.
   */
  function updateProductInformation() {

    const canonical = document.querySelector(
      'link[rel="canonical"]'
    );

    if (
      canonical &&
      canonical.href &&
      productUrlInput
    ) {
      productUrlInput.value =
        canonical.href;
    }

    /*
     * Update SKU from the currently selected
     * Shopify variant.
     */
    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (
      variantInput &&
      variantInput.value &&
      skuInput
    ) {

      const variantId =
        variantInput.value;

      fetch(
        window.Shopify.routes.root +
        'variants/' +
        variantId +
        '.js'
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'Unable to load variant.'
            );
          }

          return response.json();
        })
        .then(function (variant) {

          if (
            variant &&
            variant.sku &&
            skuInput
          ) {
            skuInput.value =
              variant.sku;
          }

        })
        .catch(function () {
          /*
           * Keep the existing SKU if the
           * variant lookup fails.
           */
        });

    }

  }

  /*
   * Open button.
   */
  openButton.addEventListener(
    'click',
    openPopup
  );

  /*
   * Close buttons.
   */
  closeButtons.forEach(function (button) {

    button.addEventListener(
      'click',
      closePopup
    );

  });

  /*
   * Escape key.
   */
  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        popup.getAttribute('aria-hidden') === 'false'
      ) {
        closePopup();
      }

    }
  );

  /*
   * SEND QUESTION.
   *
   * Uses the existing Shopify contact form
   * endpoint through a normal POST request.
   */
  if (submitButton) {

    submitButton.addEventListener(
      'click',
      function () {

        /*
         * Validate required fields.
         */
        const fields = [
          nameInput,
          emailInput,
          phoneInput,
          bikeInput,
          yearInput,
          messageInput
        ];

        for (const field of fields) {

          if (
            !field ||
            !field.checkValidity()
          ) {

            if (field) {
              field.reportValidity();
            }

            return;
          }

        }

        /*
         * Prevent double submissions.
         */
        submitButton.disabled = true;

        submitButton.textContent =
          'SENDING...';

        /*
         * Build Shopify contact form data.
         */
        const formData =
          new FormData();

        formData.append(
          'form_type',
          'contact'
        );

        formData.append(
          'utf8',
          '✓'
        );

                formData.append(
          'contact[Name]',
          nameInput.value.trim()
        );

        formData.append(
          'contact[email]',
          emailInput.value.trim()
        );

        formData.append(
          'contact[Phone]',
          phoneInput.value.trim()
        );

        formData.append(
          'contact[Bike Brand & Model]',
          bikeInput.value.trim()
        );

        formData.append(
          'contact[Bike Year]',
          yearInput.value.trim()
        );

        if (productUrlInput) {

          formData.append(
            'contact[Product URL]',
            productUrlInput.value
          );

        }

        if (skuInput) {

          formData.append(
            'contact[SKU]',
            skuInput.value
          );

        }

        formData.append(
          'contact[Message]',
          messageInput.value.trim()
        );

        fetch(
          '/contact',
          {
            method: 'POST',
            body: formData,
            headers: {
              'Accept':
                'text/html'
            }
          }
        )
          .then(function (response) {

            /*
             * Shopify normally returns the contact
             * page after processing the form.
             */
            if (!response.ok) {
              throw new Error(
                'Unable to send your question.'
              );
            }

            return response.text();

          })
          .then(function () {

                      /*
           * Success.
           */
          const title = document.getElementById(
            'ms7-compatibility-title'
          );

          if (title) {
            title.style.display = 'none';
          }

          if (popup.querySelector('.ms7-compatibility-popup__intro')) {
            popup.querySelector(
              '.ms7-compatibility-popup__intro'
            ).style.display = 'none';
          }

          if (form) {
            form.innerHTML = `
              <div class="ms7-compatibility-success">
                <strong>YOUR MESSAGE HAS BEEN SENT</strong>
                <p>
                  Thank you. We'll check the compatibility for you
                  and get back to you as soon as possible.
                </p>
              </div>
            `;
          }

          })
          .catch(function (error) {

            console.error(
              'MADSPEED7 compatibility check error:',
              error
            );

            submitButton.disabled = false;

            submitButton.textContent =
              'SEND QUESTION';

            alert(
              'Technical error: ' +
              error.message
            );

          });

      }
    );

  }

  /*
   * WhatsApp.
   */
  if (whatsappButton) {

    whatsappButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        const bike =
          bikeInput
            ? bikeInput.value.trim()
            : '';

        const year =
          yearInput
            ? yearInput.value.trim()
            : '';

        const productUrl =
          productUrlInput
            ? productUrlInput.value.trim()
            : window.location.href;

        const productTitle =
          document.querySelector(
            'meta[property="og:title"]'
          );

        const title =
          productTitle &&
          productTitle.content
            ? productTitle.content.trim()
            : 'MADSPEED7 wheel';

                const message =
          'Hello, I am currently on your site, www.madspeed7.co.uk, and would like to check the compatibility of this wheel for my bike.%0A%0A' +
          'Here is the link to the wheel I am looking at:%0A' +
          productUrl;

        /*
         * Use the same WhatsApp number as
         * the existing MADSPEED7 Need Help
         * system.
         *
         * Replace the number below with the
         * existing number if required.
         */
        const whatsappNumber =
  '447377876353';

        window.open(
          'https://wa.me/' +
          whatsappNumber +
          '?text=' +
          message,
          '_blank'
        );

      }
    );

  }

});